var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"store"},[_c('div',{staticClass:"content"},[_c('div',{attrs:{"id":"qrcode"}}),(_vm.qrCodeUrl)?_c('p',[_vm._v("请使用微信扫描二维码进行支付(请在"+_vm._s(_vm.miao)+"秒之内支付)")]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }